import { BrandConfig } from '../types/brand';

const modules = import.meta.glob('./*/brandConfig.ts', { eager: true });

const brandConfigs: Record<string, BrandConfig> = {};

for (const path of Object.keys(modules)) {
  const key = path.split('/')[1];
  const mod = modules[path] as { default?: { brandConfig?: BrandConfig }, brandConfig?: BrandConfig };
  const config = mod.brandConfig || mod.default?.brandConfig;
  if (config) {
    brandConfigs[key] = config;
  } else {
    console.warn(`Brand config at ${path} missing export`);
  }
}

export function resolveBrandConfig(name: string): BrandConfig | undefined {
  const normalized = name.toLowerCase().replace(/[^a-z0-9]/g, '_');
  return brandConfigs[normalized];
}

export { brandConfigs };
